import { Button, Col, Container, Form, Row } from "react-bootstrap";

const DemographicDetailTab = () => {
    return (
        <div className="demographic_tab_screen">
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Form>
                            <Form.Group className="form-group">
                                <Form.Label>
                                    Father/Husband Name<span>*</span>
                                </Form.Label>
                                <Form.Control type="text" placeholder="Jitender Singh" required />
                            </Form.Group>
                            <Form.Group className="form-group">
                                <Form.Label>
                                    Mother Name
                                </Form.Label>
                                <Form.Control type="text" placeholder="Jitender Kaur" />
                            </Form.Group>
                            <Row>
                                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>
                                            Date of Birth<span>*</span>
                                        </Form.Label>
                                        {/* {<Datepicker />} */}
                                        <Form.Control type="date" placeholder="DD/MM/YYYY" required />
                                        {/* <div className="date_img">
                                            <Image src={Calender} alt="..." />
                                        </div> */}

                                    </Form.Group>
                                </Col>
                                <Col xxl={3} xl={3} lg={3} md={3} sm={6} xs={6}>
                                    <Form.Group className="form-group">
                                        <Form.Label>
                                            Gender<span>*</span>
                                        </Form.Label>
                                        <Form.Select required>
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col xxl={4} xl={4} lg={4} md={4} sm={6} xs={6}>
                                    <Form.Group className="form-group">
                                        <Form.Label>
                                            Blood Group
                                        </Form.Label>
                                        <Form.Select required>
                                            <option value="AB+">AB+</option>
                                            <option value="A+">A+</option>
                                            <option value="A-">A-</option>
                                            <option value="B+">B+</option>
                                            <option value="B-">B-</option>
                                            <option value="AB-">AB-</option>
                                            <option value="O+">O+</option>
                                            <option value="O-">O-</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                    <Form.Group className="form-group">
                                        <Form.Label>
                                            Age<span>*</span>
                                        </Form.Label>
                                        <Form.Control type="text" placeholder="20" required />
                                    </Form.Group>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                    <Form.Group className="form-group">
                                        <Form.Label>
                                            Marital Status<span>*</span>
                                        </Form.Label>
                                        <Form.Select required>
                                            <option selected>Select</option>
                                            <option value="single">Single</option>
                                            <option value="married">Married</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group className="form-group">
                                <Form.Label>
                                    Occupation
                                </Form.Label>
                                <Form.Select required>
                                    <option selected>NA</option>
                                    <option value="1">NA</option>
                                    <option value="2">NA</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="form-group">
                                <Form.Label>
                                    Nationality<span>*</span>
                                </Form.Label>
                                <Form.Select required>
                                    <option selected>Indian</option>
                                    <option >Indian</option>
                                </Form.Select>
                            </Form.Group>
                            <div className="btn_area">
                                <Button className="cancelBtn" type="button" >Cancel</Button>
                                <Button className="submitBtn" type="submit">Next</Button>
                            </div>

                        </Form>
                    </Col>
                </Row>
            </Container>
        </div>
    )
};

export default DemographicDetailTab;